module.exports = __webpack_public_path__ + "static/media/icon_send_on.10d1a08e.png";